import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = ['El cardio eterno sube el cortisol y bloquea la quema de grasa visceral', 'Las dietas de hambre destruyen testosterona y te dejan sin energía para rendir', 'Los suplementos quemagrasa son cafeína cara que te da taquicardia pero no toca tu panza', 'Contar calorías ignora completamente el problema hormonal real'];
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-2">
      <div className="max-w-4xl mx-auto" data-id="element-3">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 text-center uppercase" data-id="element-4">
          No fallaste vos.{' '}
          <span className="text-red-500" data-id="element-5">Falló el método.</span>
        </h2>
        <p className="font-inter text-gray-400 text-center mb-12 text-lg max-w-2xl mx-auto" data-id="element-6">
          Ninguna de esas soluciones ataca el mecanismo correcto.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-7">
          {attempts.map((attempt, index) => <div key={index} className="flex items-start bg-dark-bg p-6 rounded-lg border border-gray-800" data-id="element-8">
              <XCircle className="w-8 h-8 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-9" />
              <p className="font-inter text-gray-300 text-lg" data-id="element-10">{attempt}</p>
            </div>)}
        </div>
      </div>
    </section>;
}